module.exports = __webpack_public_path__ + "static/media/blob.cb2f106a.svg";